import { Schema as S } from "effect";

import { CalendarSchema } from "../list-calendars/list-calendars.response";

export const FindCalendarMetaSchema = S.Struct({
  errors: S.Array(S.Unknown),
  warnings: S.Array(S.Unknown),
  query: S.Record(S.String, S.Unknown),
  itemsPerPage: S.NullOr(S.Number),
  totalItems: S.Int,
  page: S.NullOr(S.Number),
  replyCode: S.Int,
  model: S.Literal("calendar"),
});

export const FindCalendarResponseSchema = S.Array(CalendarSchema);

export type FindCalendarResponse = S.Schema.Type<
  typeof FindCalendarResponseSchema
>;
